// This icon file is generated automatically.
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M414.26 768l-72.93-69.52L536.86 512 341.33 325.52 414.26 256l268.4 256-268.4 256z" } }] }, "name": "right", "theme": "outlined" };
export default RightOutlined;
